<template>
  <Container v-model="tab">
    <template #tabs>
      <v-tabs v-if="$vuetify.breakpoint.smAndDown" v-model="tab" grow>
        <v-tab href="#tab-abertos">Abertos</v-tab>
        <v-tab href="#tab-finalizados">Finalizados</v-tab>
        <v-tab href="#tab-ambulatoriais">Ambulatoriais</v-tab>
      </v-tabs>
      <v-btn-toggle v-else v-model="tab" color="primary" rounded>
        <v-btn value="tab-abertos">Abertos</v-btn>
        <v-btn value="tab-finalizados">Finalizados</v-btn>
        <v-btn value="tab-ambulatoriais">Ambulatoriais</v-btn>
      </v-btn-toggle>
    </template>
    <template #tabAbertos>
      <v-col cols="12">
        <v-expand-transition>
          <div
            class="next-attendence"
            :style="{
              color: $vuetify.theme.themes.light.primary,
              backgroundColor: $vuetify.theme.themes.light.tertiary
            }"
            @click="$router.push({ name: 'agendamentos' })"
          >
            <v-icon color="primary" size="23">mdi-bell-outline</v-icon>
            <div class="pl-3">
              Para acessar a consulta é necessário o preenchimento da sua ficha clínica e da assinatura. Lembre-se que o
              acesso à sala de atendimento é liberado somente {{ minutesBeforeAppointment }} minutos antes e
              {{ minutesAfterAppointment }} minutos depois do horário marcado.
            </div>
          </div>
        </v-expand-transition>
      </v-col>
      <v-col cols="12">
        <div v-if="carregandoAgendamentos" class="text-center mt-6">
          <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
        </div>
        <v-alert v-else-if="erroAgendamentos" type="error" text class="mt-6">
          Não foi possível carregar seus agendamentos. Tente novamente mais tarde.
        </v-alert>
        <v-data-iterator v-else :items="abertos" hide-default-footer>
          <template #default="{ items }">
            <v-row>
              <v-col v-for="item in items" :key="item.idAso" cols="12" sm="6" lg="4">
                <AgendamentoCard v-bind="item" @on-click="preencherFichaClinica(item)" />
              </v-col>
            </v-row>
          </template>
          <template #no-data>
            <h3 class="text-center secondary-font">Não encontramos nenhum agendamento em aberto</h3>
          </template>
        </v-data-iterator>

        <v-row no-gutters justify="center" align="center" class="mt-10">
          <v-btn
            v-if="!express && enableTelemedicina"
            to="/agendar-exame"
            color="primary"
            class="secondary-font text-capitalize font-weight-bold py-7"
            elevation="24"
            rounded
            x-large
          >
            Agendar Exame
            <v-spacer></v-spacer>
            <v-icon right>mdi-arrow-right-bold-circle-outline</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" class="mt-4">
          <WhatsappButton v-if="brand.features.showWhatsappButton" />
        </v-row>
      </v-col>
    </template>
    <template #tabFinalizados>
      <v-col cols="12">
        <div v-if="carregandoAgendamentos" class="text-center mt-6">
          <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
        </div>
        <v-alert v-else-if="erroAgendamentos" type="error" text class="mt-6">
          Não foi possível carregar seus agendamentos. Tente novamente mais tarde.
        </v-alert>
        <v-data-iterator v-else :items="finalizados" hide-default-footer>
          <template #default="{ items }">
            <v-row>
              <v-col v-for="item in items" :key="item.idAso" cols="12" sm="6" lg="4">
                <AgendamentoCard
                  v-bind="item"
                  finalizado
                  @open-aso="openAso(item)"
                  @open-ficha-clinica="openFichaClinica(item)"
                />
              </v-col>
            </v-row>
          </template>
          <template #no-data>
            <h3 class="text-center secondary-font">Não encontramos nenhum atendimento ambulatorial</h3>
          </template>
        </v-data-iterator>
      </v-col>
    </template>
    <template #tabAmbulatoriais>
      <v-col cols="12">
        <div v-if="carregandoAmbulatoriais" class="text-center mt-6">
          <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
        </div>
        <v-alert v-else-if="erroAmbulatoriais" type="error" text class="mt-6">
          Não foi possível carregar seus atendimentos ambulatoriais. Tente novamente mais tarde.
        </v-alert>
        <v-data-iterator v-else :items="ambulatoriais" hide-default-footer>
          <template #default="{ items }">
            <v-row class="ma-2 scroll-card">
              <v-col v-for="item in items" :key="item.id" cols="12" sm="6" lg="4">
                <AtendimentoAmbulatorialCard :atendimentoAmbulatorial="item" @on-edit="onEditAmbulatorial" />
              </v-col>
            </v-row>
            <SelecionarHorarioStepper
              @on-update-agendamento="getAgendamentosAmbulatoriais"
              :dialog.sync="selectHorarioDialog"
              v-if="selectHorarioDialog"
              :tipoAtendimento="selectedAtendimento.tipo"
              :id="selectedAtendimento.id"
            />
          </template>
          <template #no-data>
            <h3 class="text-center secondary-font">Não encontramos nenhum agendamento finalizado</h3>
          </template>
        </v-data-iterator>
      </v-col>
    </template>
  </Container>
</template>

<script>
import Axios from '@/utils/axios'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import ambulatorioDigitalService from '@/services/ambulatorioDigital'
import AtendimentoAmbulatorialCard from '@/modules/AtendimentoAmbulatorial/AtendimentoAmbulatorialCard.vue'
import SelecionarHorarioStepper from '../../modules/AmbulatorioDigital/SelecionarHorarioStepper.vue'
import brandMixin from '@/mixins/brandMixin'
const Container = () => import('@/modules/Agendamento/AgendamentoContainer')
const AgendamentoCard = () => import('@/modules/Agendamento/AgendamentoCard')
const WhatsappButton = () => import('@/core/components/WhatsappButton')

export default {
  components: {
    Container,
    AgendamentoCard,
    WhatsappButton,
    AtendimentoAmbulatorialCard,
    SelecionarHorarioStepper,
  },
  mixins: [brandMixin],
  data: () => ({
    tab: 'tab-abertos',
    abertos: [],
    finalizados: [],
    ambulatoriais: [],
    carregandoAgendamentos: true,
    erroAgendamentos: false,
    carregandoAmbulatoriais: true,
    erroAmbulatoriais: false,
    express: true,
    selectHorarioDialog: false,
    selectedAtendimento: {
      id: null,
      tipo: null
    },
    minutesBeforeAppointment: 10,
    minutesAfterAppointment: 30
  }),
  computed: {
    ...mapGetters('user', ['agendamentoExpress', 'enableTelemedicina']),
  },
  methods: {
    ...mapMutations('fichaClinica', {
      setIdAso: 'SET_ID_ASO'
    }),
    ...mapActions('fichaClinica', ['preparaFichaClinica']),

    async getAgendamentos() {
      this.carregandoAgendamentos = true
      this.erroAgendamentos = false
      try {
        const { data } = await Axios.get('/agendamentos')
        this.abertos = data.abertos
        this.finalizados = data.finalizados
      } catch (error) {
        this.erroAgendamentos = true
        this.$showErrorMessage(error.response.data.message)
      } finally {
        this.carregandoAgendamentos = false
      }
    },
    async getAgendamentosAmbulatoriais() {
      this.carregandoAmbulatoriais = true
      this.erroAmbulatoriais = false
      try {
        const { data } = await ambulatorioDigitalService.getAgendamentos()
        this.ambulatoriais = data.atendimentos
      } catch (error) {
        this.erroAmbulatoriais = true
        this.$showErrorMessage(error.response.data.message)
      } finally {
        this.carregandoAmbulatoriais = false
      }
    },
    async preencherFichaClinica(aso) {
      this.$showLoading()
      const success = await this.preparaFichaClinica(aso)
      this.$hideLoading()

      if (success) this.$router.push({ name: 'Ficha Clínica' })
    },
    async openAso(aso) {
      this.$showLoading()
      try {
        const { data } = await Axios.get(`/arquivo-retorno/${aso.idAso}/download`)
        window.open(data.fileUrl, '_blank')
      } catch (error) {
        console.log(error)
      } finally {
        this.$hideLoading()
      }
    },
    async openFichaClinica(aso) {
      this.$showLoading()
      try {
        const { data } = await Axios.get(`/ficha-clinica/${aso.idAso}/download`)
        window.open(data.fileUrl, '_blank')
      } catch (error) {
        console.log(error)
      } finally {
        this.$hideLoading()
      }
    },
    onEditAmbulatorial({ id, tipo }) {
      this.selectedAtendimento.id = id
      this.selectedAtendimento.tipo = tipo
      this.selectHorarioDialog = true
    }
  },
  mounted() {
    this.getAgendamentos()
    this.getAgendamentosAmbulatoriais()
    this.express = this.agendamentoExpress
  }
}
</script>

<style>
.scroll-card {
  overflow-y: scroll;
}
.next-attendence {
  display: flex;
  flex-direction: row;
  border-radius: 10px;
  background-color: #e7e9fc;
  align-items: center;
  padding: 10px;
  font-size: 0.8rem;
  font-weight: 500;
  margin-top: 10px;
  cursor: pointer;
}
@media only screen and (min-width: 960px) {
  .next-attendence {
    font-size: 1rem !important;
    height: 55px;
  }
}
</style>
